module.exports = __webpack_public_path__ + "static/img/Frame(24).80aa322d.png";